module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./BankCardView.js"));
	}, "BankCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BankCardView!./src/pages/Shop/Member/Wallet/BankCard/BankCardView.js
// module id = 1998
// module chunks = 367